import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SocialFacebookIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<g clipPath="url(#clip0_7286_166590)">
				<path
					d="M23.5 12.0699C23.5 5.71858 18.3513 0.569855 12 0.569855C5.64872 0.569855 0.5 5.71858 0.5 12.0699C0.5 17.8098 4.70538 22.5674 10.2031 23.4302V15.3941H7.2832V12.0699H10.2031V9.53626C10.2031 6.65407 11.92 5.06204 14.5468 5.06204C15.805 5.06204 17.1211 5.28665 17.1211 5.28665V8.11673H15.671C14.2424 8.11673 13.7969 9.0032 13.7969 9.91264V12.0699H16.9863L16.4765 15.3941H13.7969V23.4302C19.2946 22.5674 23.5 17.8098 23.5 12.0699Z"
					fill="#1877F2"
				/>
			</g>
			<defs>
				<clipPath id="clip0_7286_166590">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

SocialFacebookIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SocialFacebookIcon;
